<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Account</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Application Store</a>
                        </li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Private Practice 101</a>
                        </li>
                    </ul>

                    <h3>Private Practice 101 (South Africa)</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Application Store</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 8px;"></div>

                    <Accordion>
                        <AccordionTab header="Module #1 :: Getting your Private Practice Number">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Getting your Private Practice Number</h2>

                                        To get your practice number you will need to apply for it through the Practice
                                        Code Numbering System
                                        (PCNS) with the Board of Healthcare Funders (BHF).
                                        If you follow the information below, our team will help you with this process.

                                        <br><br>
                                        Note that this process can only be started once you have your registration
                                        confirmation with the
                                        HPCSA.

                                        <br><br>
                                        <h3>Documents Required for Practice Number Application</h3>
                                        - Certified copy of your ID Book/Card
                                        <br>
                                        - Certified copy of your HPCSA Independent Practice Registration Certificate
                                        <br>
                                        - Proof from the HPCSA that your fees are up to date. (This can be the statement
                                        downloaded from the
                                        HPCSA portal)

                                        <br><br>
                                        <h3>Application Forms for the Practice Number</h3>
                                        - Please email us the documents listed above to info@kitrin.com.
                                        <br>
                                        - Our team will then prepare your application form, and send this to you for
                                        review and signature,
                                        within three (3) working days of receipt of the documents.
                                        <br>
                                        - Once the completed form is emailed back to us at info@kitrin.com, our team
                                        will do final checks
                                        and submit the application to the BHF within
                                        three (3) working days of receipt of the signed application form.. It will take
                                        between 10 to 20
                                        working days for the application to be
                                        reviewed and approved by the BHF.

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Module #2 :: Registering with Medical Aids">
                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Registering with Medical Aids</h2>

                                        There are medical aid companies in South Africa, and there are administrators of
                                        medical aid
                                        companies. In some cases,
                                        these are one and the same. However, in most cases, the medical aid is
                                        administered by an external
                                        administrator. This means
                                        that if one registers with the medical aid administrator, it is highly likely
                                        that the you would
                                        then be registered across
                                        all medical aid schemes that they administer.

                                        <br><br>
                                        Based on this information, we strongly advise you to prioritise the following
                                        registrations listed
                                        below (which our team will assist with),
                                        and then handle each of the other registrations as you need to in terms of
                                        patients that you will
                                        encounter in your private
                                        practice. Since you have four months from the date of service and most
                                        registrations with medical
                                        aid companies take 4-6 weeks,
                                        you should have amply time to submit the registration for the medical aid
                                        scheme. This approach will
                                        allow you to be registered
                                        with around 100 medical aid schemes within a short time period.

                                        <br><br>
                                        Note that this process can only be started once you have your practice number
                                        confirmation from the
                                        BHF.

                                        <br><br>
                                        <h3>Documents Required for Medical Aid Registrations</h3>
                                        - Certified copy of your ID Book/Card
                                        <br>
                                        - Certified copy of your HPCSA Independent Practice Registration Certificate
                                        <br>
                                        - Proof from the HPCSA that your fees are up to date. (This can be the statement
                                        downloaded from the
                                        HPCSA portal)
                                        <br>
                                        - Proof from the BHF of your practice number.
                                        <br>
                                        - Proof of the bank account for your private practice.

                                        <br><br>
                                        <h3>Application Forms for the Medical Aid Registration</h3>
                                        - Please email us the documents listed above to info@kitrin.com.
                                        <br>
                                        - Our team will then prepare your registration forms, and send this to you for
                                        review and signature,
                                        within five (5) working days of receipt of the documents.
                                        <br>
                                        - Once the completed form is emailed back to us at info@kitrin.com, our team
                                        will do final checks
                                        and submit the application to each of the
                                        medical aid companies within five (5) working days of receipt of the signed
                                        registration forms.
                                        It will take between 15 to 30 working days for the registrations to be reviewed
                                        and approved by each
                                        medical aid scheme.

                                        <br><br>
                                        <h3>1. Discovery (29 medical aid schemes)</h3>
                                        a. AFRISAM
                                        <br>
                                        b. ALTRON
                                        <br>
                                        c. ANGLO MEDICAL SCHEME
                                        <br>
                                        d. ANGLO VAAL
                                        <br>
                                        e. FLEXICARE CORPORATE (DISCOVERY)
                                        <br>
                                        f. BANKMED
                                        <br>
                                        g. BMW
                                        <br>
                                        h. DISCOVERY
                                        <br>
                                        i. DISCOVERY KEYCARE
                                        <br>
                                        j. DEPARTMENT OF HEALTH -DISCOVERY
                                        <br>
                                        k. EDCON
                                        <br>
                                        l. GLENCORE
                                        <br>
                                        m. IBM
                                        <br>
                                        n. LA HEALTH
                                        <br>
                                        o. LA HEALTH KEYCARE
                                        <br>
                                        p. LONMIN
                                        <br>
                                        q. MALCOR
                                        <br>
                                        r. MULTICHOICE - NASPERS - MMED
                                        <br>
                                        s. NETCARE
                                        <br>
                                        t. QUANTUM
                                        <br>
                                        u. QUANTUM KEYCARE
                                        <br>
                                        v. REMEDI
                                        <br>
                                        w. RETAIL
                                        <br>
                                        x. SAB - SABMAS
                                        <br>
                                        y. SASOLMED
                                        <br>
                                        z. TFG
                                        <br>
                                        aa. TSOGO
                                        <br>
                                        ab. UNIVERSITY OF KZN
                                        <br>
                                        ac. WITSMED (UNIVERSITY OF WITWATERSRAND)

                                        <br><br>
                                        <h3>2. Medscheme (27 medical aid schemes)</h3>
                                        a. AECI (COMPREHENSIVE, COMPREHENSIVE SELECT AND VALUE OPTION )
                                        <br>
                                        b. AECI VALUE
                                        <br>
                                        c. AFA BROADREACH
                                        <br>
                                        d. AFA CORPORATE
                                        <br>
                                        e. BARLOWORLD
                                        <br>
                                        f. BONITAS
                                        <br>
                                        g. BONITAS (BONESSENTIAL & BONESSENTIAL SELECT)
                                        <br>
                                        h. COMMED
                                        <br>
                                        i. COMMED ROOTS
                                        <br>
                                        j. DEPARTMENT OF HEALTH -MEDSCHEME
                                        <br>
                                        k. ELLERINE HOLDINGS
                                        <br>
                                        l. FEDHEALTH
                                        <br>
                                        m. HORIZON
                                        <br>
                                        n. HOSMED
                                        <br>
                                        o. HOSMED ACCESS + ESSENTIAL
                                        <br>
                                        p. HOSMED -ESSENTIAL OPTION
                                        <br>
                                        q. LIBERTY
                                        <br>
                                        r. LIBERTY TRADITIONAL BASIC
                                        <br>
                                        s. MBMED
                                        <br>
                                        t. NEDGROUP
                                        <br>
                                        u. ONECARE - NEDGROUP
                                        <br>
                                        v. PARMED
                                        <br>
                                        w. POLMED
                                        <br>
                                        x. SABC
                                        <br>
                                        y. TOPMED
                                        <br>
                                        z. TOPMED NETWORK (use FEDHEALTH code F001)
                                        <br>
                                        aa. BONITAS (BONESSENTIAL & BONESSENTIAL SELECT)

                                        <br><br>
                                        <h3>3. MHG (Metropolitan Health Group) (6 medical aid schemes)</h3>
                                        a. BOPHELO Metropolitan Lesotho
                                        <br>
                                        b. GEMS BERYL & TANZANITE
                                        <br>
                                        c. GEMS EMERALD ONYX & RUBY
                                        <br>
                                        d. DEPARTMENT OF HEALTH -MHG-WESTERN CAPE
                                        <br>
                                        e. DEPARTMENT OF HEALTH -MHG -GAUTENG
                                        <br>
                                        f. MEDIPOS

                                        <br><br>
                                        <h3>4. MMI (8 medical aid schemes)</h3>
                                        a. BP
                                        <br>
                                        b. ENGEN
                                        <br>
                                        c. FISHMED
                                        <br>
                                        d. GOLDEN ARROW
                                        <br>
                                        e. IMPERIALMED
                                        <br>
                                        f. METROPOLITAN HEALTH / STAFF
                                        <br>
                                        g. PG GROUP
                                        <br>
                                        h. PICK AND PAY

                                        <br><br>
                                        <h3>5. MOMENTUM CONS (7 medical aid schemes)</h3>
                                        a. BOTSOGO
                                        <br>
                                        b. HEALTH4ME
                                        <br>
                                        c. MOMENTUM
                                        <br>
                                        d. MOTO HEALTHCARE ( CLASSIC & OPTIMUM)
                                        <br>
                                        e. TRANSMED GUARDIAN PLAN
                                        <br>
                                        f. TRANSMED PRIME PLAN (PRIVATE NETWORK PLAN)
                                        <br>
                                        g. WOOLTRU (Saver and Comprehensive Option )

                                        <br><br>
                                        <h3>6. MOMENTUM THEBE YA BOPHELO (2 medical aid schemes)</h3>
                                        a. ANGLOGOLD ASHANTI
                                        <br>
                                        b. THEBEMED

                                        <br><br>
                                        <h3>7. UNIVERSAL (20 medical aid schemes)</h3>
                                        a. Universal Health & Accident Plan (UHAP)
                                        <br>
                                        b. BCIMA (Building & Construction Industry)
                                        <br>
                                        c. BCIMA (PLUS OPTION )
                                        <br>
                                        d. COMPCARE MEDICAL SCHEME
                                        <br>
                                        e. FLIMAS - Fidelity Life Medical Aid Society
                                        <br>
                                        f. GRINTEK
                                        <br>
                                        g. HOSMED VALUE CORE
                                        <br>
                                        h. IMPILO - UNIVERSAL
                                        <br>
                                        i. MASSMART
                                        <br>
                                        j. MEDIONE SICK FUND
                                        <br>
                                        k. MASSMART EMS
                                        <br>
                                        l. OLD MUTUAL STAFF - NETWORK PLAN & SELECT PLAN
                                        <br>
                                        m. REEBOKRANT WORKERS TRUST
                                        <br>
                                        n. TIGER BRANDS
                                        <br>
                                        o. TRANSMED LINK PLAN ( STATE PLUS NETWORK)
                                        <br>
                                        p. UNIVERSAL WELLNESS
                                        <br>
                                        q. UNIVERSAL HEATLH ACCIDENT
                                        <br>
                                        r. WORKPLACE HEALTH PLAN (WORKERPLAN)
                                        <br>
                                        s. NTSIKA (WCMAS)
                                        <br>
                                        t. Watch Tower

                                    </div>

                                </div>
                            </div>
                        </AccordionTab>


                        <AccordionTab header="Module #3 :: Private Practice Management Course">


                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Private Practice Management Course</h2>

                                        Accreditation number : AOCP001/6269/12/2026<br>

                                        5 Ethics CEUs, HPCSA Level 1<br>

                                        <br><br>
                                        The running of a healthcare private practice is a difficult transition for most
                                        healthcare
                                        practitioners.
                                        In this course, we review the HPCSA
                                        guidelines and provide insight and actionable learnings to help any healthcare
                                        practitioner
                                        with
                                        their
                                        private practice management.

                                        <br><br>
                                        Our Presenter, Ingrid James, will be introducing the concepts, as well as
                                        discussing the
                                        applications of
                                        each area within a healthcare private practice.

                                        <br><br>
                                        <h3>Aims of the Programme</h3>
                                        1. Strategy and mapping out your journey.<br>
                                        2. Ethical considerations.<br>
                                        3. Marketing considerations.<br>
                                        4. Legal considerations.<br>
                                        5. People and human resources considerations.<br>
                                        6. Processes and operational functional considerations.<br>
                                        7. Billing, financials and tax considerations.<br>
                                        8. Continuous learning and educational considerations.<br>
                                        9. Coaching and mentorship considerations.<br>
                                        10. Tools and resources.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Ingrid James</h3>
                                        Clinical Psychologist<br>
                                        MA (Clin Psychology) Zululand<br>

                                        <br><br>
                                        Ingrid is a Senior Clinical Psychologist, with special interest in the
                                        maintenance of
                                        well-being and
                                        the
                                        prevention of mental illness.
                                        She has been in private practice since 2005 based in Gauteng, South Africa.

                                        <br><br>
                                        She trained at the University of Zululand in a community psychology based
                                        programme.
                                        Zululand in
                                        Northern
                                        KwaZulu Natal and its
                                        surrounding areas is a predominantly mining area where supporting towns sprang
                                        up as a
                                        result of
                                        migrant
                                        employees. The aim of
                                        the University in developing the community psychology programme was to create
                                        support for
                                        the
                                        displaced
                                        migrant employees,
                                        facilitate tolerance in this cultural melting pot, and most of all create an
                                        environment of
                                        physical
                                        and
                                        emotional well-being
                                        for the employees and their families.

                                        <br><br>
                                        She was initially moved to concentrate on well-being and prevention of mental
                                        illness during
                                        my
                                        internship
                                        where I worked
                                        as a consultant psychologist to companies such as Mondi (Richards Bay and
                                        Empangeni), South
                                        African
                                        Ports
                                        Authority (Portnet),
                                        Ticor and Richards Bay Coal Terminal (RBCT). She was responsible for the
                                        Employee Assistance
                                        Programme
                                        (EAP) in each of these
                                        companies and was confronted on a daily basis with individuals who struggled to
                                        cope with
                                        their
                                        unfamiliar
                                        environments and
                                        the demands of work. The research for her Master’s Thesis was The Effect of
                                        Exercise on
                                        Psychological
                                        Well-Being in the Workplace.

                                        <br><br>
                                        During the course of her practice, she has dealt with a number of clients with
                                        work related
                                        difficulties.
                                        She was instrumental
                                        in establishing the EAP programme in a medical hospital during my Community
                                        Service. After
                                        establishing a
                                        successful private practice,
                                        she branched out into Coaching and received accreditation through Success
                                        Factory. This was
                                        mainly
                                        due to
                                        the yearning to be able to
                                        intervene at an earlier stage of distress.

                                        <br><br>
                                        She is an internationally accredited assessor of the EQ-i and MBTI New. Her
                                        training as a
                                        clinical
                                        psychologist, exposure to
                                        coaching and work experience equips her to understand the relationships of
                                        individuals both
                                        with
                                        themselves and each other.
                                        She excels at managing difficult situations through her attitude,
                                        professionalism and
                                        ethical point
                                        of
                                        view.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Email :: ingrid@ingridnagaya.com<br>
                                        Website:: www.ingridnagaya.com

                                        <br><br><br><br>
                                        <h3>Watch Video for Course 4 :: Module #1</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/64edbb01-06bf-481f-ad7f-729b1dc832a4?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Watch Video for Course 4 :: Module #2</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/65473340-58c0-491a-8006-65d8217ec97f?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Watch Video for Course 4 :: Module #3</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/4492fd8e-a8b8-4ae4-8ba3-2ef180f6da88?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Watch Video for Course 4 :: Module #4</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/6329e0f6-655d-488b-ac34-88e7f65b8c61?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Watch Video for Course 4 :: Module #5</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/034a5fbb-1284-46b8-919d-6693a8ea845c?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course 4 :: Module #1</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/f95097b3-4745-4693-abc4-9781f3e31c27?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course 4 :: Module #2</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/33fcd6e1-d215-4bea-83db-c99af80e8e62?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course 4 :: Module #3</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/fc5b90b9-4900-4fa4-88f3-6011bc43231b?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course 4 :: Module #4</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/4d830d37-1cad-4c7b-beaa-d3343c0153ee?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course 4 :: Module #5</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/3c72e8c8-9e75-4cce-a346-712cec9b65e7?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy" style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <div>
                                            <br><br><br><br>
                                            <h3>Complete Questionnaire for Course</h3>

                                            <div class="field">
                                                <label for="question1">1. Can you use the expression "hospital",
                                                    "clinic" or
                                                    "institute" in
                                                    your practice name?</label>
                                                <Dropdown v-model="module1.answer1" :options="module1Question1"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. How many core ethical values and standards are
                                                    there in
                                                    terms of
                                                    clinical practice?</label>
                                                <Dropdown v-model="module1.answer2" :options="module1Question2"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Can information on a patient be shared on
                                                    social media
                                                    platforms
                                                    (if no consent is received from patient)?</label>
                                                <Dropdown v-model="module1.answer3" :options="module1Question3"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Can a practitioner divulge information
                                                    regarding a patient
                                                    under
                                                    certain circumstances?</label>
                                                <Dropdown v-model="module1.answer4" :options="module1Question4"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. How long can a practitioner employ a locum
                                                    tenen?</label>
                                                <Dropdown v-model="module1.answer5" :options="module1Question5"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireModule1"></Button>
                                        </div>

                                    </div>
                                </div>
                            </div>


                        </AccordionTab>

                        <AccordionTab header="Module #4 :: Previous Weekly Client Support Meetings">
                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Previous Weekly Client Support Meetings</h2>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.vimeo.com/video/932027965?h=1497dec4ec&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                    width="640" height="360" frameborder="0"
                                                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                                    title="Kitrin Client Support Meeting :: 08-JAN-2024"></iframe>
                                            </div>
                                        </div>


                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.vimeo.com/video/932072957?h=72ac8860bc&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                    width="640" height="480" frameborder="0"
                                                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                                    title="Kitrin Client Support Meeting :: 14-NOV-2023"></iframe>
                                            </div>
                                        </div>


                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.vimeo.com/video/932097761?h=46053ec30c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                    width="640" height="360" frameborder="0"
                                                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                                    title="Kitrin Client Support Meeting :: 29-JAN-2024"></iframe>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Module #5 :: Access to IsoEvolve Practice Management Software">
                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Access to IsoEvolve Practice Management Software</h2>

                                        You have a Free Plan to the IsoEvolve Adaptive Practice Management Software, to
                                        allow you to start your private practice with all features for
                                        your private practice. The Free Plan includes everything you need to run a calm,
                                        organised practice — from client onboarding and bookings to invoicing and
                                        financial visibility. You’re not testing a demo. You’re using the real system,
                                        just with a sensible client limit while you grow. You can upgrade to a paid subscription
                                        at any stage using the details on our website at https://kitrin.com/pricing
                                        <br><br>
                                        If you have any questions or concerns related to this access, please send an
                                        email to
                                        info@kitrin.com.

                                        <br><br><br>
                                        <h3>Full Overview and Setup Guide of the IsoEvolve Software</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://iframe.mediadelivery.net/embed/568195/d9af70ec-e518-4f98-976d-09c63538e4ff?responsive=true"
                                                    loading="lazy"
                                                    style="position: absolute; inset: 0; width: 100%; height: 100%; border: 0;"
                                                    allowfullscreen>

                                                </iframe>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                    </Accordion>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            userConfiguration: {},
            module1: {},
            module1Question1: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            module1Question2: [
                {name: 'A. One', code: 'A'},
                {name: 'B. Five', code: 'B'},
                {name: 'C. Thirteen', code: 'C'},
                {name: 'D. Sixteen', code: 'D'},
                {name: 'E. Twenty', code: 'E'},
            ],
            module1Question3: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            module1Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            module1Question5: [
                {name: 'A. One Month', code: 'A'},
                {name: 'B. One Year', code: 'B'},
                {name: 'C. Six Months', code: 'C'},
                {name: 'D. Six Years', code: 'D'},
                {name: 'E. Nine Months', code: 'E'},
            ],
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            try {
                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;

                console.log("[Applications][mounted] userConfigData.data = ", userConfigData.data);
            } catch (e) {
                console.error("[Applications][mounted] Could not find user config for user = ", this.userStore.user.id);
                this.userConfiguration = {
                    enableAppstoreApp1: 'N',
                    enableAppstoreApp2: 'N',
                    enableAppstoreApp3: 'N',
                    enableAppstoreApp4: 'N',
                    enableAppstoreApp5: 'N',
                    enableAppstoreApp6: 'N',
                    enableAppstoreApp7: 'N',
                    enableAppstoreApp8: 'N',
                    enableAppstoreApp9: 'N',
                    enableAppstoreApp10: 'N',
                    enableAppstoreApp11: 'N'
                };
            }
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        callReset() {
            console.log("[ProfileApplication001][callReset] Beginning.");
            this.safeNavigate('/commonApplicationStore');
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
